// removed by extract-text-webpack-plugin
module.exports = {"heroMedia":"src-components-modules-Hero-HeroMedia-style----general-module---heroMedia---1mRMb textAlign-center display-flex flexDirection-column justifyContent-spaceAround","height":"src-components-modules-Hero-HeroMedia-style----general-module---height---TBoYe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Hero/HeroMedia/style/general.module.css
// module id = 1472
// module chunks = 168707334958949